@let _pulseSurvey = pulseSurvey(); @if (_pulseSurvey) { @if
(_pulseSurvey.BackgroundImage) {
<div class="survey-image d-flex justify-content-center align-items-center mb-3">
	<img alt="Survey Image" [src]="_pulseSurvey.BackgroundImage | image: 'svg'">
</div>
}
<div>
	<h4>{{ _pulseSurvey.testName | translate }}</h4>
	<h5>{{ _pulseSurvey.pretext | translate }}</h5>
</div>
<p>{{ _pulseSurvey.description | translate }}</p>
<div>
	{{ "number_of_questions" | translate }} {{ _pulseSurvey.numberOfQuestion }}
</div>
<div>
	{{ "estimated_time" | translate }} {{ _pulseSurvey.estimatedTime }}
	{{ "Minutes" | translate }}
</div>
<app-collapse
	[title]="'Intro_Userdata_Header' | translate"
	[id]="'protection-data'"
>
	<div>
		<p [innerHtml]="'Intro_Userdata_Content' | translate"></p>
	</div>
</app-collapse>
<app-collapse
	[title]="'Intro_Content_Header' | translate"
	[id]="'protection-data'"
>
	<div>
		<p [innerHtml]="'Consent_Pulse' | translate"></p>
	</div>
</app-collapse>

<div class="form-check">
	<input
		class="form-check-input"
		type="checkbox"
		id="consent-checkbox"
		[checked]="consentValue()"
		(change)="consentValue.set($any($event.target).checked)"
	>
	<label class="form-check-label" for="consent-checkbox">
		{{ "pulse_survey_consent_text" | translate }}
	</label>
</div>

<button
	class="btn btn-primary btn-circle align-self-center"
	[disabled]="!consentValue()"
	[routerLink]="['/pulse-survey', _pulseSurvey.Id]"
>
	{{ "start" | translate }}
</button>
}
